module.exports = __webpack_public_path__ + "img/Grubenkind.8d349aed.svg";